export default __webpack_public_path__ + "static/media/contact.26d44393.jpg";